import Logger from '../../utils/logger';
import ErrorTracker from './trackers/error-tracker';
import ImpressionTracker from './trackers/impression-tracker';
import AdPointTracker from './trackers/ad-point-tracker';
import RewindTracker from './trackers/rewind-tracker';
import MuteTracker from './trackers/mute-tracker';
import UnmuteTracker from './trackers/unmute-tracker';
import PauseTracker from './trackers/pause-tracker';
import ResumeTracker from './trackers/resume-tracker';
import ExpandTracker from './trackers/expand-tracker';
import CollapseTracker from './trackers/collapse-tracker';

const EventTrackers = {
  impression: ImpressionTracker,
  creativeView: ImpressionTracker,

  start: AdPointTracker,
  firstQuartile: AdPointTracker,
  midpoint: AdPointTracker,
  thirdQuartile: AdPointTracker,
  complete: AdPointTracker,

  error: ErrorTracker,
  rewind: RewindTracker,
  mute: MuteTracker,
  unmute: UnmuteTracker,
  pause: PauseTracker,
  resume: ResumeTracker,

  expand: ExpandTracker,
  fullscreen: ExpandTracker,
  collapse: CollapseTracker,
  exitFullscreen: CollapseTracker,

  acceptInvitation: null,
  close: null,
  clickThrough: null,
  clickTracking: null,
};

export default class DAIReporter {
  _player = null;
  _ad = null;
  _trackers = [];

  constructor(player) {
    this._player = player;
  }

  _stopTrackers() {
    for (const tracker of this._trackers) {
      tracker.stop();
    }
  }

  updateAd(ad) {
    this._stopTrackers();
    this._trackers = [];

    this._ad = ad;

    if (ad) {
      this._createTrackers();
    }
  }

  startNewEvents(ad) {
    if (ad === this._ad) {
      ad.trackingEvents.forEach((e) => {
        if (!this._trackers.find(t => t._event.eventType === e.eventType)) {
          this._createTracker(e);
        }
      });
    }
  }

  _createTracker(event) {
    const Tracker = EventTrackers[event.eventType];

    // ignore some events which we cannot track
    if (Tracker === null) {
      return;
    }

    if (!Tracker) {
      Logger.warn(`DAIReporter: got unexpected ad tracking event type: "${event.eventType}"`);
      return;
    }

    const tracker = new Tracker(this._player, this._ad, event);
    tracker.start();

    this._trackers.push(tracker);
  }

  _createTrackers() {
    for (const event of this._ad.trackingEvents) {
      this._createTracker(event);
    }
  }

  stop() {
    this._stopTrackers();
    this._trackers = [];
    this._ad = null;
  }
}
